import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'ticketSourceEnglish' })
export class TicketSourceEnglishPipe implements PipeTransform {
    transform(ticketSource: TicketSource): string {
        if (typeof ticketSource === 'string') {
            ticketSource = +ticketSource;
        }

        switch (ticketSource) {
            case TicketSource.form:
                return 'Form';
            case TicketSource.facebook:
                return 'Facebook';
            case TicketSource.instagram:
                return 'Instagram';
            case TicketSource.email:
                return 'Email';
            case TicketSource.chat:
                return 'Chat';
            case TicketSource.youtube:
                return 'YouTube';
            case TicketSource.googleMyBusiness:
                return 'GoogleMyBusiness';
            case TicketSource.trustpilot:
                return 'Trustpilot';
            case TicketSource.googlePlayMarket:
                return 'GooglePlayMarket';
            case TicketSource.appStore:
                return 'AppStore';
            case TicketSource.whatsApp:
                return 'WhatsApp';
            case TicketSource.tikTok:
                return 'TikTok';
            case TicketSource.api:
                return 'Api';
            default:
                return '';
        }
    }
}
